import React from 'react'
import styled from '@emotion/styled'
import { Visible } from '@gousto-internal/citrus-react'

import { CookingTimeIcon } from '../CookingTimeIcon/CookingTimeIcon'
import { VariantHeader } from '../VariantHeader'

import { Image } from './Image'
import { SoldOutOverlay } from './SoldOutOverlay'
import { cssImageStyle, cssImageWrapper, cssRecipeImageAndCookingTimeWrapper } from './styles'

const ImageWrapper = styled.button({ ...cssImageWrapper, label: '-TileImage' } as any)
const ContentWrapper = styled.div(cssRecipeImageAndCookingTimeWrapper as any)

export function TileImage({ categoryId }: { categoryId: string }) {
  return (
    <ImageWrapper>
      <SoldOutOverlay />

      <ContentWrapper>
        <Image lazy styles={cssImageStyle} />

        <CookingTimeIcon />
      </ContentWrapper>

      <Visible display={['none', 'block']}>
        <VariantHeader categoryId={categoryId} />
      </Visible>
    </ImageWrapper>
  )
}
